/**
 * GA4カスタムイベント送信ユーティリティ
 * window.gtag が存在する場合のみ送信（ローカル・テスト環境でエラーにならない）
 */

const LAST_VISIT_KEY       = 'ondoku_last_visit';
const ACQUISITION_KEY      = 'ondoku_acquisition_source';

/**
 * GA4カスタムイベントを送信する
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, {
      acquisition_source: getAcquisitionSource(),
      ...params,
    });
  }
}

/**
 * 最終訪問日からの経過日数を返す（初回訪問は -1）
 */
export function getLastVisitDays() {
  try {
    const last = localStorage.getItem(LAST_VISIT_KEY);
    if (!last) return -1;
    return Math.floor((Date.now() - Number(last)) / (1000 * 60 * 60 * 24));
  } catch {
    return -1;
  }
}

/**
 * 現在の日時をlocalStorageに保存する
 */
export function updateLastVisit() {
  try {
    localStorage.setItem(LAST_VISIT_KEY, String(Date.now()));
  } catch {
    // localStorage が使えない環境では無視
  }
}

/**
 * 流入元を判定する（現在のdocument.referrerから）
 */
export function getReferrerSource() {
  const ref = (typeof document !== 'undefined' ? document.referrer : '') || '';
  if (ref.includes('loilonote'))                        return 'loilonote';
  if (ref.includes('t.co') || ref.includes('twitter')) return 'twitter';
  if (ref.includes('google'))                           return 'google';
  if (ref === '')                                       return 'direct';
  return 'other';
}

/**
 * 初回流入元（acquisition_source）を取得する。
 * - まだ記録がなければ現在のdocument.referrerから判定して保存する
 * - 2回目以降はlocalStorageの値を返す（LoiLoNote経由ユーザーを継続追跡するため）
 */
export function getAcquisitionSource() {
  try {
    const saved = localStorage.getItem(ACQUISITION_KEY);
    if (saved) return saved;
    // 初回：referrerから判定して保存
    const source = getReferrerSource();
    localStorage.setItem(ACQUISITION_KEY, source);
    return source;
  } catch {
    return getReferrerSource();
  }
}
